import React from 'react';

export const learnIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="28"
    viewBox="0 0 26 28"
  >
    <defs>
      <linearGradient
        id="a"
        x1="-13.522%"
        x2="86.045%"
        y1="50.387%"
        y2="50.387%"
      >
        <stop offset="50%" stopColor="#F2B997" />
        <stop offset="55.61%" stopColor="#EBAA87" />
      </linearGradient>
      <linearGradient id="b" x1="-14.015%" x2="85.985%" y1="50%" y2="50%">
        <stop offset="50%" stopColor="#F2B997" />
        <stop offset="55.61%" stopColor="#EBAA87" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(4.952)">
        <path
          fill="url(#a)"
          fillRule="nonzero"
          d="M13.619 17.652c-.619 1.34-2.352 2.435-3.838 2.435h-2.91c-1.485 0-3.219-1.096-3.838-2.435L2.29 16.01c-.619-1.34-1.114-3.287-1.114-4.383S2.414 9.678 3.9 9.678h8.852c1.486 0 2.724.852 2.724 1.948s-.495 3.044-1.114 4.383l-.743 1.643z"
        />
        <path
          fill="url(#b)"
          fillRule="nonzero"
          d="M15.476 10.104c0 1.461-1.238 2.679-2.724 2.679h-8.79c-1.486 0-2.724-1.218-2.724-2.679V6.33c0-4.26 3.157-4.504 7.12-4.504 3.961 0 7.118.244 7.118 4.504v3.774z"
        />
        <path
          fill="#987A5D"
          fillRule="nonzero"
          d="M16.095 10.957h-1.238a1.231 1.231 0 0 1-1.238-1.218V6.696h2.476v4.26zM12.01 2.983S10.71 4.26 5.448 4.26C.31 4.26.619 0 .619 0H9.348l2.662 2.983z"
        />
        <path
          fill="#987A5D"
          fillRule="nonzero"
          d="M10.524 0H8.667v3.043h2.476c1.362 0 2.476 1.096 2.476 2.435v1.826h2.476V5.478C16.095 2.435 13.62 0 10.524 0z"
        />
        <path
          stroke="#987A5D"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.238"
          d="M12.01 8.522H8.667M2.105 7.913s2.228-.609 3.466-.609"
        />
        <path
          fill="#EBAA87"
          fillRule="nonzero"
          d="M15.167 12.783h-1.548v-2.13c0-.853.681-1.523 1.548-1.523.866 0 1.547.67 1.547 1.522v.609c0 .852-.68 1.522-1.547 1.522z"
        />
        <ellipse
          cx="10.833"
          cy="10.47"
          fill="#7B4C46"
          fillRule="nonzero"
          rx="1"
          ry="1"
        />
        <ellipse
          cx="4.643"
          cy="10.47"
          fill="#7B4C46"
          fillRule="nonzero"
          rx="1"
          ry="1"
        />
      </g>
      <path
        fill="#46A8D8"
        fillRule="nonzero"
        d="M11.762 27.391s-1.114-1.217-3.095-1.217H1.238V11.565h7.429c1.98 0 3.095 1.218 3.095 1.218V27.39z"
      />
      <path
        fill="#4593C9"
        fillRule="nonzero"
        d="M14.238 27.391s1.114-1.217 3.095-1.217h7.429V11.565h-7.429c-1.98 0-3.095 1.218-3.095 1.218V27.39z"
      />
      <path
        fill="#2B66AB"
        fillRule="nonzero"
        d="M14.238 27.391S13.867 28 13 28c-.929 0-1.238-.609-1.238-.609V12.783s.371.547 1.238.547c.929 0 1.238-.547 1.238-.547V27.39z"
      />
      <path
        fill="#F2B997"
        fillRule="nonzero"
        d="M4.643 20.635c-.186 1.035-1.176 1.887-2.229 1.887H1.92C.867 22.522 0 21.67 0 20.635v-3.47c0-1.095.867-1.948 1.919-1.948H3.59c1.053 0 1.796.853 1.61 1.887l-.557 3.53z"
      />
      <path
        fill="#EBAA87"
        fillRule="nonzero"
        d="M21.357 20.635c.186 1.035 1.176 1.887 2.229 1.887h.433c1.052 0 1.92-.852 1.92-1.887v-3.47c0-1.035-.868-1.887-1.92-1.887h-1.671c-1.053 0-1.796.852-1.61 1.887l.62 3.47z"
      />
    </g>
  </svg>
);
